import React from "react";

export default function SelectField({
    label,
    id,
    name,
    value,
    onChange,
    required,
    options = [],
    placeholder = "Select...",
    className = "",
    error
}) {
    return (
        <div className={`d-flex flex-column align-items-start mb-3 ${className}`}>
            <label htmlFor={id || name} className="form-label ps-1">
                {label}
                {required && <span style={{ color: "red" }}> *</span>}
            </label>

            <select
                id={id || name}
                name={name}
                value={value}
                onChange={onChange}
                required={required}
                className={`form-control ${error ? "is-invalid" : ""}`}
            >
                <option value="">{placeholder}</option>
                {options?.map((opt, index) => (
                    <option key={index} value={opt?.value}>
                        {opt?.label}
                    </option>
                ))}
            </select>
            {error && <div className="invalid-feedback">{error}</div>}
        </div>
    );
}